import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8fbeb7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a8fbeb7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fbeb7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8fbeb7a')) {
      api.createRecord('a8fbeb7a', component.options)
    } else {
      api.reload('a8fbeb7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a8fbeb7a&scoped=true", function () {
      api.rerender('a8fbeb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/recordUsedManage/index.vue"
export default component.exports